import { createErrorReportingAsyncThunk } from "../../helpers";
import axios from "../../../axios";
import { createSlice } from "@reduxjs/toolkit";
import * as tPromise from "io-ts-promise";
import { CargosReportTableData, cargosReportTableDataT } from "./types";
import { AppThunkAction } from "../../../redux-store";
import { DateTime } from "luxon";
import { userStorage } from "../../../helpers/user-storage";

const prefix = "data/cargo-report";

// Saved per user and restored once the user is known (see checkAuthState).
export const CARGOS_REPORT_TEAMS_FILTER = "cargosReportTeamsFilter";

type State = {
  cargoModalData: Record<string, CargosReportTableData>;
  cargosReportPageData: CargosReportTableData;
  filterTeamIds: string[];
};

const initialState: State = {
  cargoModalData: {},
  cargosReportPageData: [],
  filterTeamIds: [],
};

export const loadIndividualCargoReport = createErrorReportingAsyncThunk(
  `${prefix}/load-individual-cargo-report`,
  async (input: { cargoId: string }) => {
    return axios
      .get("/api/mileage-reports/for-cargos", { params: input })
      .then((x) => x.data)
      .then(tPromise.decode(cargosReportTableDataT));
  }
);

export const loadCargosReport = createErrorReportingAsyncThunk(
  `${prefix}/load-cargos-report`,
  async (input: {
    from: DateTime;
    to: DateTime;
    customerId: string | null;
    trailerId: string | undefined;
    teamIds: string[] | null;
  }) => {
    if (input.teamIds?.length === 0) {
      return [];
    }
    return axios
      .get("/api/mileage-reports/for-cargos", {
        params: {
          from: input.from.toFormat("yyyy-MM-dd"),
          to: input.to.toFormat("yyyy-MM-dd"),
          ...(input.customerId ? { customerId: input.customerId } : {}),
          ...(input.trailerId ? { trailerId: input.trailerId } : {}),
          ...(input.teamIds && {
            teamIds: input.teamIds.join(","),
          }),
        },
      })
      .then((x) => x.data)
      .then(tPromise.decode(cargosReportTableDataT));
  }
);

export const setSelectedTeamsAndSave =
  (payload: string[]): AppThunkAction =>
  (dispatch, getState) => {
    userStorage.setItem(CARGOS_REPORT_TEAMS_FILTER, JSON.stringify(payload));
    dispatch(slice.actions.setSelectedTeams(payload));
  };

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    setSelectedTeams: (state, action) => {
      state.filterTeamIds = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadCargosReport.fulfilled, (state, action) => {
      state.cargosReportPageData = action.payload;
    });
    builder.addCase(loadIndividualCargoReport.fulfilled, (state, action) => {
      state.cargoModalData[action.meta.arg.cargoId] = action.payload;
    });
  },
});

export const { setSelectedTeams } = slice.actions;

export default slice.reducer;
